export default __webpack_public_path__ + "static/media/img (1).118b45f0.jpg";